export default "__VITE_ASSET__X9yF6lrr__"